// ** Redux Imports
import { combineReducers } from "redux";

// ** Reducers Imports
import auth from "./auth";
import navbar from "./navbar";
import layout from "./layout";
import user from "./user";
import corps from "./corporations/index";
import buildings from "./buildings";
import fall from "./fall";
import alert from "./alert";
import automatedVisitLogs from "./automatedVisitLogs";
import raLogs from "./raLogs";
import robotLogs from "./robotLogs";
import sequences from "./sequences";
import visitors from "./visitors";
import users from "./users";
import residents from "./residents";
import visits from "./visits";
import robots from "./robots";
import rooms from "./rooms";
import calendars from "./calendars";
import slots from "./slots";
import languages from "./languages";
import jokes from "./jokes";
import trivia from "./trivia";
import topics from "./topics";
import robotConnectionLogs from "./robotConnectionLogs";
import emailTemplates from "./emailTemplates";
import titles from "./titles";
import geoLocations from "./geoLocations";
import adminLanguages from "./adminLanguages";
import databaseBackups from "./databaseBackups";

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  user,
  corps,
  buildings,
  sequences,
  users,
  visitors,
  residents,
  visits,
  robots,
  rooms,
  calendars,
  slots,
  alert,
  automatedVisitLogs,
  raLogs,
  robotLogs,
  fall,
  jokes,
  languages,
  trivia,
  topics,
  robotConnectionLogs,
  emailTemplates,
  titles,
  geoLocations,
  adminLanguages,
  databaseBackups
});

export default rootReducer;
